export default {
    namespaced: true,
    state: {
        layouts: {
            default: {
            }
        }
    }
};
